<div class="container-fluid">
    <div class="image">
        <img alt="Sign Up Image" [src]="singUpHeading" />
    </div>
    <div class="container heading-wrapper">
        <div class="row g-0">
            <div class="content col-lg-12 col-xl-6">
                <div class="title-wrapper">
                    <h2 class="heading-title mb-xl-3">
                        PBS LearningMedia has curated FREE, curriculum-aligned videos, interactives,
                        teaching tips, discussion questions, and more for teachers like you!
                    </h2>
                    <span class="heading-description">
                        Sign up for a free account to explore thousands of trusted, high-quality
                        teaching resources that harness the power of media to capture attention,
                        spark curiosity, and support critical thinking and deeper learning.
                    </span>
                </div>

                <div class="brands">
                    <div class="pbs-logo">
                        <img alt="PBS Logo" [src]="pbsLogo" />
                    </div>
                    <div class="wgbh-logo">
                        <img alt="WGBH Image" [src]="wgbhLogo" />
                    </div>
                    <div class="pbs-kids-logo">
                        <img alt="PBS Kids Logo" [src]="psbKidsLogo" />
                    </div>
                </div>
            </div>
            <div class="col-lg-0 col-xl-1"></div>
            <div class="col-lg-12 col-xl-5">
                <app-auth-modal-content
                    [isSignUp]="true"
                    [nextURL]="nextUrl"
                    [pbsEmailRegister]="true"
                    [description]="description"
                    [registerDescription]="authSectionDescription"
                    [registerLinkText]="authSectionLinkText"
                    [title]="authSectionTitle"
                    class="auth-section"
                ></app-auth-modal-content>
            </div>
        </div>
    </div>
</div>
<div class="container marketing-wrapper">
    <app-marketing-description [imageSide]="'left'" [marketingImage]="pbsClassroomReadyResources">
        <h2 class="title">Engage With Trusted, Award-Winning Content</h2>
        <p class="description">
            We’ve curated a wide range of standards-aligned classroom resources, to supplement
            curriculum, and are customizable to fit into your lesson plans. Our content is created
            with teachers and vetted by experts working with PBS, your local PBS member station, and
            trusted educational partners like the Library of Congress and the Smithsonian. With just
            a few clicks, you can access firsthand accounts from veterans, footage from the depths
            of the ocean, science lessons from space, historical letters and photographs, multimedia
            lesson plans perfect for helping students form deeper, more meaningful connections to
            the curriculum, and so much more. Here are a few of our most popular collections for
            grades 3-12:
        </p>
        <ul>
            <li>
                <a routerLink="/collection/us-history-collection/home/">U.S. History Collection</a>
            </li>
            <li>
                <a routerLink="/collection/nova/">NOVA</a>
            </li>
            <li>
                <a routerLink="/collection/kenburnsclassroom/home/">Ken Burns in the Classroom</a>
            </li>
            <li>
                <a routerLink="/collection/pbs-digital-studios/">PBS Digital Studios</a>
            </li>
            <li>
                <a routerLink="/collection/newshour-classroom/">PBS NewsHour Classroom</a>
            </li>
            <li>
                <a routerLink="/collection/universe/home/">
                    Bringing the Universe to America’s Classrooms
                </a>
            </li>
            <li>
                <a
                    routerLink="/collection/civics-collection-citizenship-government-and-our-constitutional-democracy/home/"
                >
                    CIVICS Collection
                </a>
            </li>
            <li>
                <a routerLink="/collection/shakespeare-uncovered/"
                    >Great Performances: Shakespeare</a
                >
            </li>
        </ul>
    </app-marketing-description>
    <app-marketing-description [marketingImage]="pbsKidsImage">
        <h2 class="title">Inspire Your Youngest Learners</h2>
        <p class="description">
            PBS KIDS applies a whole-child approach to learning with media, supporting all of the
            key developmental areas an early learner needs to be successful in school — and life. We
            work hand-in-hand with early childhood education experts, advisors, classroom
            practitioners, and PBS KIDS producers to create developmentally-appropriate educational
            content. You’ll find free videos, games, hands-on activities, printables, planners, and
            more featuring beloved PBS KIDS characters. Here are some of our most popular
            collections for grades PreK-2:
        </p>
        <ul>
            <li>
                <a routerLink="/collection/changing-seasons/">Changing Seasons</a>
            </li>
            <li>
                <a routerLink="/collection/daniel-tigers-neighborhood/"
                    >Daniel Tiger’s Neighborhood</a
                >
            </li>
            <li>
                <a routerLink="/collection/wild-kratts/">Wild Kratts</a>
            </li>
            <li>
                <a routerLink="/collection/super-why/">SuperWHY!</a>
            </li>
            <li>
                <a routerLink="/collection/you-me-community/">You, Me & Community</a>
            </li>
            <li>
                <a routerLink="/collection/molly-of-denali/">Molly of Denali™</a>
            </li>
            <li>
                <a routerLink="/collection/weather-hunters/">Weather Hunters</a>
            </li>
        </ul>
    </app-marketing-description>
    <app-marketing-description [imageSide]="'left'" [marketingImage]="teacherAndStudentClassroom">
        <h2 class="title">Access All of the FREE PBS LearningMedia Features and Tools</h2>
        <p class="description">
            When you create a FREE account and sign into PBS LearningMedia, you can:
        </p>
        <ul>
            <li>See state-level curriculum standards</li>
            <li>“Favorite” or save classroom resources</li>
            <li>Create playlists using “Folders”</li>
            <li>Create class rosters</li>
            <li>Build lessons in the PBS LearningMedia Lesson Builder</li>
            <li>Share content to your Google Classroom</li>
        </ul>
        <span class="w-100 d-block">
            Visit our
            <a
                href="/help/sharing-content-across-platforms/"
                target="_blank"
                rel="noopener noreferrer"
            >
                <b>Help page</b>
            </a>
            to learn more about our teacher-friendly features and view video tutorials to get the
            most out of your PBS LearningMedia experience.
        </span>
    </app-marketing-description>
</div>
<div class="container-fluid testimonials-section">
    <div class="container">
        <div class="testimonials-wrapper">
            <h2 class="title">What Teachers Are Saying</h2>
            <h5 class="description">
                From St. Louis, Missouri to Durham, North Carolina, educators across the country
                trust PBS LearningMedia for its trusted, high-quality content, user-friendly
                interface, and its ability to engage students in the classroom. Here’s what they
                have to say:
            </h5>
            <div class="row-auto row-eq-height g-0">
                <div class="col-lg-12 col-xl-4 testimonial">
                    <app-testimonial>
                        <div class="name">Mallory Mbalia</div>
                        <div class="profession">Kindergarten, Wake County, NC</div>
                        <div class="opinion">
                            "PBS LearningMedia empowers students to explore independently, at their
                            own pace which helps build their confidence and desire to succeed."
                        </div>
                    </app-testimonial>
                </div>
                <div class="col-lg-12 col-xl-4 testimonial">
                    <app-testimonial>
                        <div class="name">Don Goble</div>
                        <div class="profession">
                            Broadcast Technology, Film & Multimedia Instructor, St. Louis, MO
                        </div>
                        <div class="opinion">
                            "As teachers, we are constantly bombarded with new tools, new devices,
                            and new apps. Finding trustworthy resources can be daunting so having a
                            resource like PBS LearningMedia is very valuable."
                        </div>
                    </app-testimonial>
                </div>
                <div class="col-lg-12 col-xl-4 testimonial">
                    <app-testimonial>
                        <div class="name">Mig Hayes</div>
                        <div class="profession">
                            6th-12th Grade Teacher & Media Specialist, Durham, NC
                        </div>
                        <div class="opinion">
                            "...your challenge as a teacher is to serve a range of students - from
                            the most accelerated to those struggling to succeed. By having tools
                            like PBS LearningMedia, I can give my students a video to view at night
                            and by the time they come back to school, they will have had time to
                            digest the information on their own."
                        </div>
                    </app-testimonial>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="container">
    <div class="call-to-action-wrapper">
        <h5 class="title">
            Ready to inspire your students with thousands of high-quality, trusted resources?
        </h5>
        <app-button (click)="scrollToTop()" class="call-to-action-button">
            Create an Account Now
            <app-icon class="ms-2 mb-1" type="Arrow-down"></app-icon>
        </app-button>
    </div>
</div>
